import style from './Footer.module.scss'

export default function Footer() {
    return <footer className={style.footer}>
        <p className={style.footerText}>
            ©2021 by Kera Lab
        </p>
    </footer>
}
